import { UI } from '../lib/ui';

interface QtyStepperProps {
  value: number;
  max: number;
  onChange: (value: number) => void;
}

export function QtyStepper({ value, max, onChange }: QtyStepperProps) {
  return (
    <div className="nvd-claim-portal__qty" aria-label={UI.quantity}>
      <button
        type="button"
        className="nvd-claim-portal__qty-button"
        onClick={() => onChange(value - 1)}
        disabled={value <= 1}
        aria-label={UI.decrease}
      >
        −
      </button>
      <span className="nvd-claim-portal__qty-value">{value}</span>
      <button
        type="button"
        className="nvd-claim-portal__qty-button"
        onClick={() => onChange(value + 1)}
        disabled={value >= max}
        aria-label={UI.increase}
      >
        +
      </button>
    </div>
  );
}
